import { Tag, Tooltip } from '@all-manager/design-system-v2';
import type { SubTopicDatabase } from '../../../../types';
import { displayDateTime } from '../../../../utils/formatValues';

type Props = {
  item: SubTopicDatabase;
};

export default function SubTopicState(props: Props) {
  if (props.item.archived_at) {
    const date = props.item.archived_at
      ? displayDateTime(new Date(props.item.archived_at))
      : null;

    return (
      <Tooltip title={`Archivé${date ? ` le ${date}` : ''}`} enterTouchDelay={0}>
        <Tag
          color="default"
          label="Archivé"
          variantIcon="state"
        />
      </Tooltip>
    );
  }

  if (props.item.state === 'pending') {
    return (
      <Tag
        label="En cours"
        color="pending"
        variantIcon="state"
      />
    );
  }

  return (
    <Tag
      label="Terminé"
      color="done"
      variantIcon="state"
    />
  );
}
